{
  "name": "se-product-management-ui",
  "version": "1.0.0",
  "private": true,
  "description": "Monorepo for Product Management in HQ",
  "license": "MIT",
  "scripts": {
    "build:dev-staging": "yarn nx run se-product-management-ui:build:dev-staging --configuration=ci",
    "build:production": "yarn nx run se-product-management-ui:build:production --configuration=production",
    "build:staging": "yarn nx run se-product-management-ui:build:staging --configuration=staging",
    "clean": "gts clean",
    "coverage": "yarn jest --coverage",
    "fix": "nx run-many --targets=lint -c=fix",
    "lint": "nx run-many --targets=lint",
    "setup": "yarn install --immutable",
    "start": "yarn nx run se-product-management-ui:serve --configuration=development",
    "start:dev-staging": "yarn nx run se-product-management-ui:serve --configuration=dev-staging",
    "start:staging": "yarn nx run se-product-management-ui:serve --configuration=staging",
    "test": "yarn jest",
    "ui:tests:auth": "cross-env AWS_PROFILE=se-staging gimme-aws-creds --profile=se-staging",
    "ui:tests:build": "tsc -p apps/ui-e2e/tsconfig.json",
    "ui:tests:cleanup:production": "cross-env ENVIRONMENT=production playwright test --project='Tear Down' --reporter=list",
    "ui:tests:cleanup:staging": "cross-env ENVIRONMENT=staging playwright test --project='Tear Down' --reporter=list",
    "ui:tests:open:local": "cross-env ENVIRONMENT=development playwright test --project='All Tests' --ui",
    "ui:tests:open:pr": "cross-env ENVIRONMENT=pull-request playwright test --project='All Tests' --ui",
    "ui:tests:open:production": "cross-env ENVIRONMENT=production playwright test --project='All Tests' --ui",
    "ui:tests:open:staging": "cross-env ENVIRONMENT=staging playwright test --project='All Tests' --ui",
    "ui:tests:run:local": "cross-env ENVIRONMENT=development playwright test --project='All Tests'",
    "ui:tests:run:pr": "cross-env ENVIRONMENT=pull-request playwright test --project='All Tests'",
    "ui:tests:run:production": "cross-env ENVIRONMENT=production playwright test --project='All Tests'",
    "ui:tests:run:staging": "cross-env ENVIRONMENT=staging playwright test --project='All Tests'",
    "ui:tests:setup:production": "bash apps/ui-e2e/scripts/set-env.sh production",
    "ui:tests:setup:staging": "bash apps/ui-e2e/scripts/set-env.sh staging"
  },
  "resolutions": {
    "@babel/plugin-transform-modules-systemjs": "^7.29.4",
    "@eslint/eslintrc/minimatch": "^3.1.3",
    "@istanbuljs/load-nyc-config/js-yaml": "3.15.2",
    "@typescript-eslint/type-utils": "^8.70.0",
    "@typescript-eslint/types": "^8.70.0",
    "@typescript-eslint/utils": "^8.70.0",
    "brace-expansion": "^5.0.9",
    "cosmiconfig/yaml": "^1.10.3",
    "express-rate-limit": "^8.2.2",
    "fast-uri": "^3.1.7",
    "flatted": "^3.4.2",
    "glob": "^10.5.0",
    "hono": "4.13.5",
    "immutable": "5.1.8",
    "js-yaml@>=4 <5": "4.3.2",
    "lodash": "^4.18.1",
    "lodash-es": "4.18.1",
    "minimatch": "^10.2.3",
    "piscina": "4.9.3",
    "qs": "6.16.0",
    "router/path-to-regexp": "8.4.0",
    "shell-quote": "1.9.0",
    "smol-toml": "1.7.1",
    "tar": "7.5.21",
    "test-exclude": "^8.0.0",
    "tmp": "^0.2.7"
  },
  "dependencies": {
    "@angular/animations": "^22.1.7",
    "@angular/cdk": "^22.2.0",
    "@angular/common": "^22.1.7",
    "@angular/compiler": "^22.1.7",
    "@angular/core": "^22.1.7",
    "@angular/forms": "^22.1.7",
    "@angular/platform-browser": "^22.1.7",
    "@angular/platform-browser-dynamic": "^22.1.7",
    "@angular/platform-server": "^22.1.7",
    "@angular/router": "^22.1.7",
    "@datadog/browser-rum": "^7.14.0",
    "@datadog/browser-rum-angular": "^7.14.0",
    "@ngrx/component": "^22.0.1",
    "@ngrx/component-store": "^22.0.1",
    "@ngrx/effects": "^22.0.1",
    "@ngrx/operators": "^22.0.1",
    "@ngrx/router-store": "^22.0.1",
    "@ngrx/store": "^22.0.1",
    "@ngrx/store-devtools": "^22.0.1",
    "@nx/angular": "^23.2.1",
    "@nx/devkit": "^23.2.1",
    "@sportngin/se-commerce-sdk": "3.4.0",
    "@swc/helpers": "~0.5.23",
    "@types/quill": "^2.0.14",
    "jwt-decode": "^4.0.0",
    "ngx-image-cropper": "^9.1.7",
    "ngx-quill": "^31.0.1",
    "quill": "2.0.3-shadow-1",
    "rxjs": "~7.8.2",
    "se-analytics": "4.1.1",
    "se-analytics-js": "1.2.3",
    "se-fe-alert": "10.0.2",
    "se-fe-api": "9.0.1",
    "se-fe-attachment-service": "8.0.1",
    "se-fe-banner": "^10.0.3",
    "se-fe-button": "10.2.1",
    "se-fe-card": "11.1.0",
    "se-fe-carousel": "9.2.0",
    "se-fe-chip": "11.3.2",
    "se-fe-domain-environment": "8.0.1",
    "se-fe-empty-state": "^10.1.0",
    "se-fe-form-field": "10.2.0",
    "se-fe-form-field-multiselect": "11.1.1",
    "se-fe-form-field-options": "11.1.1",
    "se-fe-form-field-quantity": "^12.0.0",
    "se-fe-form-field-text": "10.1.0",
    "se-fe-form-service": "^10.0.0",
    "se-fe-frame-router": "^9.1.3",
    "se-fe-grid": "11.1.1",
    "se-fe-header": "11.2.1",
    "se-fe-icon": "^12.0.0",
    "se-fe-image-uploader": "10.3.2",
    "se-fe-indicator-dot": "^9.0.1",
    "se-fe-inline-list": "9.0.1",
    "se-fe-link": "11.1.0",
    "se-fe-menu": "14.1.1",
    "se-fe-modal": "14.2.0",
    "se-fe-overlay": "9.3.1",
    "se-fe-page": "11.1.0",
    "se-fe-pagination": "11.0.2",
    "se-fe-position": "8.0.1",
    "se-fe-scroll": "8.1.1",
    "se-fe-select": "^6.0.0",
    "se-fe-skeleton": "^4.0.1",
    "se-fe-spinner": "10.0.1",
    "se-fe-styles": "7.0.0",
    "se-fe-switch": "10.1.1",
    "se-fe-table": "13.0.3",
    "se-fe-tabs": "^13.0.1",
    "se-fe-test-id": "^3.0.0",
    "se-fe-themes": "12.0.0",
    "se-fe-toast": "14.0.0",
    "se-fe-toolbar": "12.0.0",
    "se-fe-tooltip": "^14.0.0",
    "se-fe-wysiwyg": "11.0.0",
    "se-resource-types": "^4.0.0",
    "tslib": "^2.8.1",
    "zone.js": "0.16.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^22.1.8",
    "@angular-devkit/core": "^22.1.8",
    "@angular-devkit/schematics": "^22.1.8",
    "@angular-eslint/eslint-plugin": "^22.5.0",
    "@angular-eslint/eslint-plugin-template": "^22.5.0",
    "@angular-eslint/template-parser": "^22.5.0",
    "@angular/build": "^22.1.8",
    "@angular/cli": "^22.1.8",
    "@angular/compiler-cli": "^22.1.7",
    "@angular/language-service": "^22.1.7",
    "@eslint/eslintrc": "^3.3.7",
    "@eslint/js": "^10.0.1",
    "@html-eslint/eslint-plugin": "^0.66.1",
    "@html-eslint/parser": "^0.66.1",
    "@nx/eslint": "^23.2.1",
    "@nx/eslint-plugin": "^23.2.1",
    "@nx/jest": "^23.2.1",
    "@nx/js": "^23.2.1",
    "@nx/web": "^23.2.1",
    "@nx/workspace": "^23.2.1",
    "@playwright/test": "^1.63.0",
    "@schematics/angular": "^22.1.8",
    "@sportngin/qa-automation-package": "2.3.8",
    "@stylistic/eslint-plugin": "^5.10.0",
    "@swc-node/register": "1.12.1",
    "@swc/cli": "0.8.1",
    "@swc/core": "1.16.2",
    "@types/express": "^5.0.6",
    "@types/jest": "^30.0.0",
    "@types/node": "^25.9.8",
    "@typescript-eslint/eslint-plugin": "8.70.1",
    "@typescript-eslint/parser": "8.70.1",
    "@typescript-eslint/types": "8.70.1",
    "@typescript-eslint/utils": "8.70.1",
    "angular-eslint": "^22.5.0",
    "cross-env": "^10.1.0",
    "dotenv": "^17.4.2",
    "eslint": "10.11.0",
    "eslint-config-prettier": "10.1.8",
    "eslint-plugin-markdownlint": "^1.0.0",
    "eslint-plugin-n": "^18.3.0",
    "eslint-plugin-prettier": "^5.5.6",
    "gts": "^7.0.0",
    "jest": "^30.5.2",
    "jest-environment-jsdom": "^30.5.2",
    "jest-marbles": "^4.0.1",
    "jest-preset-angular": "17.0.0",
    "ng-mocks": "^14.18.1",
    "nx": "^23.2.1",
    "prettier": "^3.9.9",
    "sass": "^1.105.0",
    "tmp": "~0.2.7",
    "ts-deepmerge": "^8.0.0",
    "ts-jest": "^29.4.13",
    "ts-node": "^10.9.2",
    "typescript": "6.0.3",
    "typescript-eslint": "^8.70.1"
  },
  "packageManager": "yarn@4.18.0",
  "engines": {
    "node": "^24.15.0"
  }
}
